/**
 * D-292 - typing a time by hand, everywhere a time is picked.
 * "0930", "930", "9:30", "09:30", "9.30", "9" -> "09:30" / "09:00". Anything else -> null (the field is marked).
 * The pick from the list stays; this only adds typing digits straight into the time field.
 */
export function parseTimeInput(raw: string | null | undefined): string | null {
  const s = String(raw ?? '').trim();
  if (!s) return null;
  let h: string;
  let m: string;
  const sep = /^(\d{1,2})[:.](\d{1,2})$/.exec(s);
  if (sep) {
    h = sep[1];
    m = sep[2].length === 1 ? `0${sep[2]}` : sep[2]; // "9:3" is not a time anyone means; "9:30" / "9:05" are
    if (sep[2].length === 1) return null;
  } else if (/^\d{1,2}$/.test(s)) {
    h = s; m = '00';
  } else if (/^\d{3,4}$/.test(s)) {
    h = s.slice(0, s.length - 2); m = s.slice(-2);
  } else {
    return null;
  }
  const hh = Number(h);
  const mm = Number(m);
  if (!Number.isInteger(hh) || !Number.isInteger(mm) || hh > 23 || mm > 59) return null;
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}

/** `iso` with its LOCAL time of day replaced by `hhmm` (same local date, seconds 0). null when either is invalid. */
export function withLocalTime(iso: string | null | undefined, hhmm: string): string | null {
  const parsed = parseTimeInput(hhmm);
  if (!iso || !parsed) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const [h, m] = parsed.split(':').map(Number);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
}

/** The error text of a failed save, pulled from an axios-style error (server message first). */
export function saveErrorText(err: unknown, fallback: string): string {
  const e = err as { error?: { message?: string }; response?: { data?: { error?: { message?: string } | string; message?: string } }; message?: string };
  const d = e?.response?.data;
  const fromData = typeof d?.error === 'string' ? d.error : d?.error?.message ?? d?.message;
  return e?.error?.message || fromData || fallback;
}
